import { useApp } from "contexts/BookingContext";
import { useLogPhotographer } from "contexts/LogPhotographerContext";
import React, { useEffect, useState } from "react";

const PhotographerHistoryPage = ({ initialData }) => {
  const { logPhotographer, filterOptions, fetchLogPhotographer } = useLogPhotographer();
  console.log("PhotographerHistoryPage initialData:", initialData);
  const logPhotographers = initialData.reservations;
  console.log("PhotographerHistoryPage logPhotographers:", logPhotographers);
  useEffect(() => {
    if (initialData) {
      fetchLogPhotographer(initialData.id);
    }
  }, [initialData, fetchLogPhotographer]);

  const formattedPrice = (price) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="mx-auto">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Photographer History : {initialData.name} </h2>

      <div className="overflow-x-auto">
        <div className="py-2 inline-block min-w-full">
          <div className="shadow table table-responsive overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Code
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Track
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {logPhotographers.map((log) => (
                  <tr key={log.created_at}>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {log.reservation_date}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">{log.code}</td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {log.status}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {log.track}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotographerHistoryPage;
